import BulkActionsContainer from '../../selection/components/BulkActionsContainer';
import { useShowSelectQuery } from '../hooks/useShowSelectQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function BulkActionsContainerAboveTable({
  BulkActionsComponent,
  canSelectAllRecords,
  getRowId,
  isBulkActionsRedesignEnabled,
  isIndexRedesignEnabled,
  rows,
  totalRowCount
}) {
  const {
    showSelectQueryInBulkActionsContainer
  } = useShowSelectQuery(rows, getRowId, canSelectAllRecords, isBulkActionsRedesignEnabled, totalRowCount);
  return /*#__PURE__*/_jsx(BulkActionsContainer, {
    BulkActionsComponent: BulkActionsComponent,
    isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
    isIndexRedesignEnabled: isIndexRedesignEnabled,
    paddingBlockEnd: "300",
    showSelectQuery: showSelectQueryInBulkActionsContainer,
    totalRowCount: totalRowCount
  });
}